import { createTheme } from "@mui/material";

const customTheme = createTheme({
    palette:{
        //can be dark or light mode
        mode:"light",
        primary:{
            main:"#00927c"
        },
        secondary:{
            main:"#EAF0F1"
        }
    }
})

export default customTheme;